
import * as THREE from 'three';
export default class CeilingLightFixture {
    constructor(scene){
        let group = new THREE.Group();

        const color = 0xFFFFFF;
        const intensity = 1;
        const light = new THREE.PointLight(color, intensity);        
        group.add(light)

        scene.add(group);
        return group;
    }


}